import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { cn as o } from "../../../utils/utils.mjs";
import { Icon as c } from "../../atoms/Icon/Icon.mjs";
const b = ({
  className: t = "",
  id: a,
  containerClassName: i = "",
  previewUrl: l,
  alt: n = "Uploaded image",
  onClose: s,
  disabled: m
}) => /* @__PURE__ */ d("div", { className: o("relative", i), children: [
  /* @__PURE__ */ e("img", { className: o("object-cover w-12 h-12 rounded-sm shrink-0", t), src: l, alt: n }),
  /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      onClick: (r) => {
        r.preventDefault(), r.stopPropagation(), s(a);
      },
      className: "absolute top-[-6px] right-[-6px] hover:cursor-pointer group-disabled:hover:cursor-not-allowed rounded-full border dark:border-neutral-dark-700 bg-neutral-dark-1000 p-1",
      disabled: m,
      "aria-label": "Remove image",
      title: "Remove image",
      children: /* @__PURE__ */ e(c, { name: "close", width: 10, height: 10 })
    }
  )
] });
export {
  b as ImageFileInputThumbnail
};
